
<header class="flex items-center px-2 border-b dark:border-white/5 sticky z-50 top-0">
  <div (click)="viewSmallScreenMenu()" class="py-2.5 lg:hidden">
      <div
          class="relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5" />
          </svg>
      </div>
  </div>
  <div class="min-w-0 flex-1">
      <div class="flex flex-1 items-center gap-4 py-1">
          <ul class="max-lg:hidden flex items-center gap-3">
              <li *ngFor="let menu of subMenus" class="relative">
                  <span *ngIf="menu.isActive" class="absolute inset-x-2 -bottom-[5px] h-px rounded-full bg-zinc-950 dark:bg-white"></span>
                  <a [routerLink]="menu.url" [ngClass]="menu.isActive ? 'bg-zinc-950/5 dark:bg-white/5' : ''"
                      class="relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left font-medium text-zinc-950 dark:text-white text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                      {{menu.title}}
                  </a>
              </li>
          </ul>
          <div aria-hidden="true" class="-ml-4 flex-1"></div>
          <ul class="flex items-center gap-2">
             <!-- clock -->
        <!-- <div
          class="flex items-center justify-center gap-2 px-2 py-2 bg-main-primary/5 max-w-52 rounded-full ring-1 ring-header-primary/10">
          <div class="hidden sm:block">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-5 h-5 text-[#505665]">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>

          </div>
          <div class="text-[10px] sm:text-xs clock font-bold text-main-primary/80 sm:tracking-[2px]">
            {{ currentTime | clockTime: "MM/dd":timeZone }} - {{currentTime | clockTime: "HH:mm:ss":timeZone}}
          </div>
        </div> -->
        <li *ngIf="digitalClock">
          <div
            class="flex items-center justify-center gap-2 px-2 py-2 bg-main-primary/5 max-w-52 rounded-full ring-1 ring-[#dadada]">
            <div class="hidden sm:block">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                class="w-5 h-5 text-[#505665] dark:text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="text-[10px] sm:text-xs clock font-bold text-main-primary/80 sm:tracking-[2px]">
              {{digitalClock}}
            </div>
          </div>
        </li>
              <li>
                  <div [appToolTip]="'Theme Switch'" (click)="toggleTheme()"
                      class="cursor-pointer relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                      <svg *ngIf="isDarkMode" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                          stroke-width="1.5" stroke="currentColor" class="size-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
                      </svg>
                      <svg *ngIf="!isDarkMode" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                          stroke-width="1.5" stroke="currentColor" class="size-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                              d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
                      </svg>
                  </div>
              </li>
              <li>
                <div [appToolTip]="'Notification Alert'" (click)="toggleNotification()" type="button"
                  class="relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium   sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5 cursor-pointer">
                  <!-- Heroicon name: outline/slash bell -->
                  <!--Mute chat-->
              
                  <svg [ngClass]="{ 'text-red-600': !isToastAlert}" *ngIf="!isToastAlert" class="size-5" viewBox="0 0 22 20"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" stroke="currentColor" fill="none" fill-rule="evenodd"
                      stroke-linecap="round" stroke-linejoin="round">
                      <g id="svgviewer-output" transform="translate(1, 1)" stroke-width="1.5">
                        <path
                          d="M0,9.76000479 C0,11.3600048 1.123,12.7540048 2.707,12.9870048 C3.836,13.1530048 4.977,13.2800048 6.13,13.3660048 C6.48,13.3920048 6.8,13.5760048 6.995,13.8670048 L9.75,18.0000024 L12.505,13.8670048 C12.7008399,13.5757557 13.0199184,13.3909484 13.37,13.3660048 C14.5151526,13.2805111 15.6568821,13.154097 16.793,12.9870048 C18.377,12.7540048 19.5,11.3610048 19.5,9.75900479 L19.5,3.74100479 C19.5,2.13900479 18.377,0.746004789 16.793,0.513004789 C14.4609588,0.170718506 12.1070269,-0.000737840669 9.75,2.38654331e-06 C7.358,2.38654331e-06 5.006,0.175004789 2.707,0.513004789 C1.123,0.746004789 0,2.14000479 0,3.74100479 L0,9.75900479 L0,9.76000479 Z"
                          id="Shape"></path>
                        <g id="Group" transform="translate(6.2145, 2.7145)">
                          <line x1="-0.964466094" y1="3.53553391" x2="8.03553391" y2="3.53553391" id="Path"
                            transform="translate(3.5355, 3.5355) rotate(45) translate(-3.5355, -3.5355)"></line>
                          <line x1="-0.964466094" y1="3.53553391" x2="8.03553391" y2="3.53553391" id="Path-2"
                            transform="translate(3.5355, 3.5355) scale(-1, 1) rotate(45) translate(-3.5355, -3.5355)"></line>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <!--UnMute chat-->
                  <svg *ngIf="isToastAlert" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                  </svg>
                </div>
              </li>
              <li>
                <div [appToolTip]="'Sound'" (click)="toggleSound()" [ngClass]="!isSound ? 'text-red-600 dark:text-red-600' : 'text-zinc-950 dark:text-white'"
                  class="relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium   sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5 cursor-pointer">
                  <svg *ngIf="isSound" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" />
                  </svg>
                  <svg *ngIf="!isSound" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" />
                  </svg>
                </div>
              </li>
              <li [appToolTip]="'Notifications'" (click)="openNotificationModal()">
                <div
                  class="relative flex min-w-0 items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
                  </svg>
                  <div *ngIf="unreadNotificationCount > 0" class="absolute -top-1.5 -right-1.5">
                    <span
                      class="inline-flex items-center justify-center text-[8px] size-[18px] font-medium leading-none text-red-100 bg-red-600 rounded-full">
                      {{ unreadNotificationCount }}
                    </span>
                  </div>
                </div>
              </li>
              <li class="relative">
                <div (click)="showUserOptions = !showUserOptions"
                    class="border border-dashed border-[#80808075] p-[5px] relative flex min-w-0 items-center gap-3 rounded-lg text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5 cursor-pointer">
                    <div>{{user.name | titlecase}}</div>
                    <div
                        class="size-6 overflow-hidden inline-grid shrink-0 align-middle [--avatar-radius:20%] [--ring-opacity:20%] *:col-start-1 *:row-start-1 outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] dark:outline-white/[--ring-opacity] rounded-[--avatar-radius] *:rounded-[--avatar-radius]">
                        <img src="{{user.profileImageURL}}" class="size-full object-cover" alt="">
                    </div>
                </div>
                <div *ngIf="showUserOptions" @openCloseProfile class="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md  bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none"
                    role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                    <div class="py-1" role="none"(outsideClick)="closeActionMenu($event)" outside-click>
                        <a routerLink="profile" (click)="onClickDropdownMenu()" class="block px-4 py-2 text-sm-light hover:text-zinc-950 dark:hover:text-white"
                            role="menuitem" tabindex="-1" id="menu-item-0">Profile</a>
                        <a href="javascript:void(0)" (click)="logout()" class="block px-4 py-2  text-sm-light hover:text-zinc-950 dark:hover:text-white"
                            role="menuitem" tabindex="-1" id="menu-item-0">Logout</a>
                    </div>
                </div>
            </li>
          </ul>
      </div>
  </div>
</header>

<audio #audioOption>
  <source src='assets/sound/notification_bell.mp3' type="audio/mp3">
</audio>
<app-notification-modal *ngIf="isShowNotificationModal" (closeModal)="isShowNotificationModal = false"></app-notification-modal>
